import styled from 'styled-components';
import { rem } from 'polished';
import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledScrollAvatar = styled.div`
  height: ${rem('162px')};
  padding: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  ${mediaqueries.greaterThan('desktop')`
    position: relative;
    padding: ${rem('0px')};
    height: auto;
  `};
`;

const StyledBtnLeft = styled(ButtonArrowLeft)`
  fill: ${props => props.theme.colors.dark};
  display: none;
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    margin-left: ${rem('5px')};
    & > svg{
      width: ${rem('18px')};
      height: ${rem('36px')};
    }
  `};
`;

const StyledBtnRight = styled(ButtonArrowRight)`
  fill: ${props => props.theme.colors.dark};
  display: none;
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    margin-right: ${rem('5px')};
    & > svg{
      width: ${rem('18px')};
      height: ${rem('36px')};
    }
  `};
`;

export { StyledScrollAvatar, StyledBtnLeft, StyledBtnRight };
